import { Button } from '@mui/material';

interface TradeActionButtonProps {
  onClick: () => void;
  disabled: boolean;
  buttonText: string;
}

export function TradeActionButton({ onClick, disabled, buttonText }: TradeActionButtonProps) {
  return (
    <Button
      fullWidth
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      sx={{
        bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#2563eb' : '#2563eb'), // Standard primary blue
        color: '#ffffff',
        textTransform: 'none',
        fontWeight: 700,
        fontSize: '1rem',
        py: 1.5,
        borderRadius: '8px',
        mb: 2,
        boxShadow: 'none',
        '&:hover': {
          bgcolor: '#1d4ed8',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          bgcolor: 'action.disabledBackground',
          color: 'action.disabled',
        },
      }}
    >
      {buttonText}
    </Button>
  );
}
